import React, { FC, useEffect } from 'react';
import { IconLargeErrorRobot } from '@byted-tiktok/tux-icons';
import Status from './Status';
import useConfig from 'packages/common/hooks/useConfig';
import { sendLog } from 'packages/common/bridge';
type ErrorPageProps = {
  darkMode?: boolean;
  errText?: string;
  page?: string;
};
export const ErrorPage500: FC<ErrorPageProps> = props => {
  const {
    t,
    query
  } = useConfig();
  const {
    darkMode,
    errText,
    page
  } = props;
  useEffect(() => {
    sendLog('load_fail_page_show', {
      page,
      enter_from: query.enter_from
    });
  }, []);
  return <Status icon={<IconLargeErrorRobot className={`text-color-${darkMode ? 'ConstTextInverse4' : 'TextQuaternary'}`} style={{
    fontSize: 56
  }} />} title={t('something_went_wrong_title', 'Something went wrong')} subtitle={t('something_went_wrong_subtitle', 'Please try again')} darkMode={darkMode} errText={errText} page={page} isRetry />;
};